/**
 * @generated SignedSource<<dfbaf07fe7df2fd0d8c34a9a1eca62b7>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { DateTime } from "@/common/relayCustomScalar";
import { Semver } from "@/common/relayCustomScalar";
import { FragmentRefs } from "relay-runtime";
export type DatasetVersionAsideContentFragment$data = {
  readonly authorsCount: {
    readonly totalCount: number;
  };
  readonly dataset: {
    readonly id: string;
    readonly name: string;
    readonly private: boolean;
    readonly shortDescription: string | null | undefined;
    readonly slug: string;
    readonly viewerCanUpdate: boolean;
    readonly " $fragmentSpreads": FragmentRefs<"DatasetVersionCreateButtonFragment" | "TagListFragment">;
  };
  readonly doi: {
    readonly full: string;
  } | null | undefined;
  readonly id: string;
  readonly license: string | null | undefined;
  readonly publishedAt: DateTime | null | undefined;
  readonly version: Semver;
  readonly viewerCanUpdate: boolean;
  readonly " $fragmentSpreads": FragmentRefs<"DatasetDOIFragment" | "DatasetVersionAsideContentAuthorsFragment" | "DatasetVersionCardFragment" | "DatasetVersionEditSheet">;
  readonly " $fragmentType": "DatasetVersionAsideContentFragment";
};
export type DatasetVersionAsideContentFragment$key = {
  readonly " $data"?: DatasetVersionAsideContentFragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"DatasetVersionAsideContentFragment">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "DatasetVersionAsideContentFragment",
  "selections": [
    (v0/*:: as any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "version",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "license",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "publishedAt",
      "storageKey": null
    },
    {
      "alias": "viewerCanUpdate",
      "args": [
        {
          "kind": "Literal",
          "name": "action",
          "value": "UPDATE_DATASET_VERSION"
        }
      ],
      "kind": "ScalarField",
      "name": "viewerCan",
      "storageKey": "viewerCan(action:\"UPDATE_DATASET_VERSION\")"
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "DOI",
      "kind": "LinkedField",
      "name": "doi",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "full",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "Dataset",
      "kind": "LinkedField",
      "name": "dataset",
      "plural": false,
      "selections": [
        (v0/*:: as any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "slug",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "name",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "shortDescription",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "private",
          "storageKey": null
        },
        {
          "alias": "viewerCanUpdate",
          "args": [
            {
              "kind": "Literal",
              "name": "action",
              "value": "UPDATE_DATASET"
            }
          ],
          "kind": "ScalarField",
          "name": "viewerCan",
          "storageKey": "viewerCan(action:\"UPDATE_DATASET\")"
        },
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "TagListFragment"
        },
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "DatasetVersionCreateButtonFragment"
        }
      ],
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "DatasetVersionCardFragment"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "DatasetVersionEditSheet"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "DatasetVersionAsideContentAuthorsFragment"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "DatasetDOIFragment"
    },
    {
      "alias": "authorsCount",
      "args": [
        {
          "kind": "Literal",
          "name": "first",
          "value": 0
        }
      ],
      "concreteType": "DatasetVersionAuthorConnection",
      "kind": "LinkedField",
      "name": "authors",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "totalCount",
          "storageKey": null
        }
      ],
      "storageKey": "authors(first:0)"
    }
  ],
  "type": "DatasetVersion",
  "abstractKey": null
};
})();

(node as any).hash = "d162ef10fcfebc64580beb6ea40c4626";

export default node;
